<template>
  <div class="circle-double">
    <div class="circle-content fade-in" @click="setRoastinValue('dark')">
      <lazy-img class="circle-content__image" :src="step.dunkel.image" />
      <lazy-img
        :fade="false"
        class="circle-content__image circle-content__image--hover"
        :class="{'circle-content__image--active': getThisData === 'dark'}"
        :src="step.dunkel.imageHover"
      />
      <div class="circle-content__pre-title" v-html="$t(step.dunkel.subtitle)"></div>
      <div class="circle-content__title" v-html="$t(step.dunkel.title)"></div>
      <div class="circle-content__description" v-html="$t(step.dunkel.description)"></div>
    </div>
    <div class="circle-content fade-in" @click="setRoastinValue('bright')">
      <lazy-img class="circle-content__image" :src="step.hell.image" />
      <lazy-img
        :fade="false"
        class="circle-content__image circle-content__image--hover"
        :class="{'circle-content__image--active': getThisData === 'bright'}"
        :src="step.hell.imageHover"
      />
      <div class="circle-content__pre-title" v-html="$t(step.hell.subtitle)"></div>
      <div class="circle-content__title" v-html="$t(step.hell.title)"></div>
      <div class="circle-content__description" v-html="$t(step.hell.description)"></div>
    </div>
  </div>
</template>

<script>
import Circle from '@/class/Circle';
import { Steps } from '@/models/steps';

export default new Circle(Steps.ROASTIN, {
  methods: {
    setRoastinValue(value) {
      this.$store.commit('resetList');
      const mod = this.mod;
      this.$store.commit('resetData');
      this.$store.commit('setStepsMod', mod);
      this.$store.commit('setMod', mod);
      this.setValue(value, true);
    }
  }
}).comp;
</script>
